import React from "react";

const Footer = () => {
  return <footer className='wrapper'>&copy; 2023 Quotivation</footer>;
};

export default Footer;
